import { useAccess } from "../../../../utils/hooks/access";
import { useScheduleContext } from "./context/useScheduleContext";

export const usePermissions = () => {
    const { type } = useScheduleContext();
    const isTeamScheduler = ["team", "template", "profile"].includes(type);
    const { hasAccess: canCreate } = useAccess(isTeamScheduler ? "schedule.canCreate" : "schedule.canCreateMySchedule");
    const { hasAccess: canCopy } = useAccess(isTeamScheduler ? "schedule.canCopy" : "schedule.canCopyMySchedule");
    const { hasAccess: canEdit } = useAccess(isTeamScheduler ? "schedule.canEdit" : "schedule.canEditMySchedule");
    const { hasAccess: canDelete } = useAccess(isTeamScheduler ? "schedule.canDelete" : "schedule.canDeleteMySchedule");
    const { hasAccess: canTransfer } = useAccess(isTeamScheduler ? "schedule.canTransfer" : "schedule.canTransferMySchedule");
    const { hasAccess: canLock } = useAccess(isTeamScheduler ? "schedule.canLock" : "schedule.canLockMySchedule");
    const { hasAccess: canUnlock } = useAccess(isTeamScheduler ? "schedule.canUnlock" : "schedule.canUnlockMySchedule");
    const { hasAccess: canApprove } = useAccess(isTeamScheduler ? "schedule.canApprove" : "schedule.canApproveMySchedule");

    const { hasAccess: canImport } = useAccess("schedule.canImport");
    const { hasAccess: canView } = useAccess("schedule.canView");

    const { hasAccess: canViewRates } = useAccess(isTeamScheduler ? "canViewRates" : "canViewMyRates");

    const { hasAccess: canCreateUnassignedShift } = useAccess("schedule.unassignedShifts.canCreate");
    const { hasAccess: canEditUnassignedShift } = useAccess("schedule.unassignedShifts.canEdit");
    const { hasAccess: canDeleteUnassignedShift } = useAccess("schedule.unassignedShifts.canDelete");
    const { hasAccess: canAssign } = useAccess("schedule.unassignedShifts.canAssign");
    const { hasAccess: canViewUnassignedShifts } = useAccess("schedule.unassignedShifts.canView");

    const { hasAccess: canApproveRequest } = useAccess("request.canApproveTeamRequest");
    const { hasAccess: canDenyRequest } = useAccess("request.canDenyTeamRequest");

    return {
        canView,
        canCreate,
        canCopy,
        canEdit,
        canDelete,
        canTransfer,
        canLock,
        canUnlock,
        canApprove,
        canViewRates,
        canImport,
        canCreateUnassignedShift,
        canEditUnassignedShift,
        canDeleteUnassignedShift,
        canViewUnassignedShifts,
        canAssign,
        canApproveRequest,
        canDenyRequest
    };
};
